function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter864",
  x: -0.0092016,
  y: -0.017244,
  width: 1.0184,
  height: 1.0345,
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.1741753
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 567.08,
  height: 302.59,
  fill: "#0d6d9e",
  fillOpacity: 0.12549,
  filter: "url(#filter864)",
  opacity: 0.42949,
  strokeWidth: 0.29652
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(142.35 58.632)",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "287 54 287 244 0 244 0 0 233 0 254 30",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#D6DCE4",
  fontFamily: "Helvetica",
  fontSize: 80
}, /*#__PURE__*/React.createElement("tspan", {
  x: 95,
  y: 153
}, "Aa")), /*#__PURE__*/React.createElement("polygon", {
  points: "287 54 233 0 233 54",
  fill: "#E1E8F0"
}));

function SvgWritingAssetTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 567.08,
    height: 302.59,
    viewBox: "0 0 567.08 302.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingAssetTypeIcon);
export default __webpack_public_path__ + "static/media/writing-asset-type-icon.7a0a8017.svg";
export { ForwardRef as ReactComponent };